import { BehaviorSubject } from 'rxjs';
import { Injectable } from "@angular/core";
import { ClientType, IsUserType, ProductType, ServiceType } from "@shared/service-proxies/service-proxies";
import { ProductServiceType } from '../../../../main/products-and-services-new/models/productServiceType.enum';

@Injectable({
    providedIn: 'root'
})

export class DefaultLayoutService {
    
    isShowClientType: ClientType;
    projectSelectedHeading: any;
    clientSelectedHeading: any;
    productSelectedHeading: any = 'ActiveProducts';
    serviceSelectedHeading: any = 'ActiveServices';
    showType: BehaviorSubject<ClientType> = new BehaviorSubject<ClientType>(null);

    userSelectedType: any;
    isShowUserType:  IsUserType.AllUsers;
    showUserType: BehaviorSubject<IsUserType.AllUsers> = new BehaviorSubject<IsUserType.AllUsers>(null);
   
    isShowProductType:  ProductType.AllProducts;
    showProductType: BehaviorSubject<ProductType.AllProducts> = new BehaviorSubject<ProductType.AllProducts>(null);
   
    isShowServiceType:  ServiceType;
    showServiceType: BehaviorSubject<ServiceType> = new BehaviorSubject<ServiceType>(null);

    isShowDashboardType: ProductServiceType;
    showDashboardType: BehaviorSubject<ProductServiceType> = new BehaviorSubject<ProductServiceType.Products>(null);

    showDashboardType1: BehaviorSubject<number> = new BehaviorSubject<number>(1);

    constructor() {

        this.showType.subscribe(res => {
            this.isShowClientType = res;
        })

        this.showUserType.subscribe(res => {
            this.isShowUserType = res;
        })

        this.showProductType.subscribe(res => {
            this.isShowProductType = res;
        })
        this.showServiceType.subscribe(res => {
            this.isShowServiceType = res;
        })

        this.showDashboardType.subscribe(res => {
            this.isShowDashboardType = res;
        })

    }
    selectedTabForProject(value: number) {
        if (value === 1) {
            this.projectSelectedHeading = 'ActiveProjects';
        }
        if (value === 2) {
            this.projectSelectedHeading = 'ArchivedProjects';
        }
        if (value === 3) {
            this.projectSelectedHeading = 'DeletedProjects';
        }
    }
    selectedTabForClient(value: number) {
        if (value === 1) {
            this.clientSelectedHeading = 'ActiveClients';
        }
        if (value === 2) {
            this.clientSelectedHeading = 'ArchivedClients';
            localStorage.setItem("testArc",'true');
        }
        if (value === 3) {
            this.clientSelectedHeading = 'DeletedClients';
        }
    }

    selectedTabForProduct(value: number) {
        if (value === 1) {
            this.productSelectedHeading = 'ActiveProducts';
        } else if (value === 2) {
            this.productSelectedHeading = 'ArchivedProducts';
        } else if (value === 3) {
            this.productSelectedHeading = 'DeletedProducts';
        }
    }

    selectedTabForService(value: number) {
        if (value === 1) {
            this.serviceSelectedHeading = 'ActiveServices';
        } else if (value === 2) {
            this.serviceSelectedHeading = 'ArchivedServices';
        } else if (value === 3) {
            this.serviceSelectedHeading = 'DeletedServices';
        }
    }

    selectedUserTab(value: number) {
        if (value === 1) {
            this.userSelectedType = 'activeUsers';
        } else if (value === 2) {
            this.userSelectedType = 'ArchivedUsers';
        } else if (value === 3) {
            this.userSelectedType = 'DeletedUsers';
        }
    }

    /*Behavioral Subject Emit */
    CheckDashboardChange(value: any) {
        this.showDashboardType1.next(value);
    }

    getLatestValue() {
        return this.showDashboardType1.asObservable();
    }

}

